import { CLASS_MUTED } from '../tools/constants/classes';
import { responsiveMediaBelow } from '../settings/responsive';
const SELECTOR_MEDIA_VIDEO = '[data-media-video]';

export class MediaThumbnail {
  private mediaThumbnailVideo: HTMLVideoElement[] = [];

  constructor(public container: HTMLElement) {
    this.container = container;
    this.mediaThumbnailVideo = Array.from(container.querySelectorAll(SELECTOR_MEDIA_VIDEO));
    this.attachEvents();
  }

  attachEvents() {

    this.mediaThumbnailVideo.forEach((videoEl) => {
      if (responsiveMediaBelow('medium')) {
        videoEl.muted = true;
        videoEl.loop = true;
        videoEl.play();
      } else {
        videoEl.pause();
        videoEl.currentTime = 0;
        videoEl.addEventListener('mouseenter', () => {
          videoEl.play();
        });
        videoEl.addEventListener('mouseleave', () => {
          videoEl.pause();
          videoEl.currentTime = 0;
        });
      }

      videoEl.addEventListener('click', () => {
        videoEl.muted = !videoEl.muted;

        if (videoEl.muted) {
          this.container.classList.add(CLASS_MUTED);
        } else {
          this.container.classList.remove(CLASS_MUTED);
        }
      });
    });
  }
}